// store/slices/TimerSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  timeLeft: 0,
  isRunning: false,
};

const TimerSlice = createSlice({
  name: "timer",
  initialState,
  reducers: {
    startTimer: (state, action) => {
      state.timeLeft = action.payload; // seconds
      state.isRunning = true;
    },
    tick: (state) => {
      if (state.timeLeft > 0) {
        state.timeLeft -= 1;
      }
      if (state.timeLeft === 0) {
        state.isRunning = false;
      }
    },
    cancelTimer: (state) => {
      state.isRunning = false;
      state.timeLeft = 0;
    },
  },
});

export const { startTimer, tick, cancelTimer } = TimerSlice.actions;
export default TimerSlice.reducer;